import React, { useContext } from "react";
import { BannerWrapperDiv, CenterBanner } from "./styled";
import kydjImg from "./img/kydj@2x.png";
import { AppContext } from "@/Context";
const LargeBanner = props => {
  const { state, dispatch } = useContext(AppContext);
  // const tempMode = state.tempMode;
  // const bt = state.pages[0] && state.pages[0].content;

  return (
    <BannerWrapperDiv className={props.className}>
      <CenterBanner src={kydjImg} alt={"开业酬宾"} />
      <div className="left-bottom-icon"></div>
    </BannerWrapperDiv>
  );
};
export default LargeBanner;
